import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import Swal from 'sweetalert2';
import Loader from "../../../../../customComponents/CustomLoader";

const AddPaymentTerms = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
  
    AddPaymemntTermsInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
  
  
    try {
      // Confirmation dialog using Swal.fire
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to add this Payment Term?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      });
  
      if (confirmation.isConfirmed) {
        setLoading(true);
        const payload = {
          payment_term_name: formData.name,
          payment_term_desc: formData.description,
          payment_days: formData.paymentdays,
          status: formData.status === "Active" ? 1 : 0,
        };
  
        if (userType === "superadmin") {
          payload.business_partner_id = formData.business_partner_id;
        } else {
          payload.business_partner_id = businessPartnerId;
        }
  
        // Make API request to add the payment term
        const response = await axiosInstance.post('/paymentterm/create', payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
  
        console.log("Payment term added successfully:", response.data);
  
        if (response.status === 200) {
          // Success alert using Swal.fire
          await Swal.fire({
            title: "Success",
            text: "Payment Term added successfully.",
            icon: "success",
            confirmButtonText: "OK",
          });
  
          navigate('/admin/manage-logistic/payment-term');
        }
      }
  
    } catch (error) {
      console.error("Error adding payment term:", error);
  
      const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
  
    } finally {
      setLoading(false);
    }
  };
  const backNavigate = () => {
    navigate("/admin/manage-logistic/payment-term");
  };

  const AddPaymemntTermsInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: { required: true },
          },
        ]
      : []),
    {
      name: "name",
      label: "Name",
      type: "text",
      placeholder: "Enter Payment Terms Name",
      required: true,
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9\s]*$/,
        message: "Only alphabets and digits are allowed*",
      },
      gridClass: "col-lg-4",
    },
    {
      name: "description",
      label: "Description",
      placeholder: "Enter Payment Terms Description",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "paymentdays",
      label: "Payment Days",
      placeholder: "Enter Payment Days",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { id: 1, label: "Active", value: "Active" },
        { id: 0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img onClick={backNavigate} src={backicon} alt="back" />
              <span className="backbtntitle">Add Payment Terms</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter the payment terms details
              </span>
              <DynamicForm
                formConfig={AddPaymemntTermsInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                onClick={() => {
                  handleFormSubmit(formData);
                }}
                className="submit-btn"
              >
                Submit
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddPaymentTerms;
